import type { Meta, StoryFn } from '@storybook/react';

import { MetaList, Avatar, useUID } from '@pega/cosmos-react-core';
import { TaskList } from '@pega/cosmos-react-work';
import type { TaskItemProps } from '@pega/cosmos-react-work';

export default {
  title: 'Work/TaskList',
  component: TaskList
} as Meta;

export const TaskListDemo: StoryFn = () => {
  const items: TaskItemProps[] = [
    {
      id: useUID(),
      processName: 'Parent process',
      name: 'Send references',
      meta: <MetaList items={[' Due in 1d', 'Priority 95']} />,
      avatar: <Avatar name='James Gregory' />
    }
  ];

  return <TaskList items={items} />;
};
